<template>
  <article>
    <section>
      <label class="blue-grey-text text-darken-4"><strong>Activity Freshness</strong></label>
    </section>
    <section>
      <div class="scale"
          :class="{'red accent-4': selectedBlock === 4, 'grey lighten-3': selectedBlock !== 4}"
      />
      <div class="scale"
          :class="{'amber accent-4': selectedBlock === 3, 'grey lighten-3': selectedBlock !== 3}"
      />
      <div class="scale"
          :class="{'light-green accent-4': selectedBlock === 2, 'grey lighten-3': selectedBlock !== 2}"
      />
      <div class="scale"
          :class="{'teal accent-4': selectedBlock === 1, 'grey lighten-3': selectedBlock !== 1}"
      />
    </section>
    <section>
      <div class="tick">
        <span class="red-text text-accent-4" v-if="selectedBlock === 4">
          <strong>Stale</strong>
        </span>
      </div>
      <div class="tick">
        <span class="amber-text text-accent-4" v-if="selectedBlock === 3">
          <strong>Fair</strong>
        </span>
      </div>
      <div class="tick">
        <span class="green-text text-accent-4" v-if="selectedBlock === 2">
          <strong>Ok</strong>
        </span>
      </div>
      <div class="tick">
        <span class="teal-text text-accent-4" v-if="selectedBlock === 1">
          <strong>Fresh</strong>
        </span>
      </div>
    </section>
  </article>
</template>

<script>
import axios from 'axios';

export default {
  name: 'RangeFreshness',
  components: {},
  props: {
    companyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      freshness: null,
    };
  },
  computed: {
    selectedBlock() {
      const thirtyDaysAgo = new Date(new Date() - 1000 * 60 * 60 * 24 * 30);
      const sixtyDaysAgo = new Date(new Date() - 1000 * 60 * 60 * 24 * 60);
      const ninetyDaysAgo = new Date(new Date() - 1000 * 60 * 60 * 24 * 90);
      if (this.freshness > thirtyDaysAgo) { return 1; }
      if (this.freshness > sixtyDaysAgo) { return 2; }
      if (this.freshness > ninetyDaysAgo) { return 3; }
      if (!this.freshness) { return 5; }
      return 4;
    },
  },
  watch: {},
  methods: {
    async fetchFreshness() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/companies/freshness/?company_id=${this.companyId}`);
      if (data) {
        this.freshness = new Date(data);
      }
    },
  },
  mounted() {
    this.fetchFreshness();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.scale {
  display: inline-block;
  height: 15px;
  width: 30px;
  border-left: 1px solid $tmf-black;
  border-top: 1px solid $tmf-black;
  border-bottom: 1px solid $tmf-black;
  &:first-of-type {
    border-radius: 5px 0px 0px 5px;
  }
  &:last-of-type {
    border-right: 1px solid $tmf-black;
    border-radius: 0px 5px 5px 0px;
  }
}

.tick {
  position: relative;
  display: inline-block;
  height: 10px;
  width: 30px;
  font-size: 0.75rem;
  bottom: 5px;
}
</style>
